import { Icon } from "@chakra-ui/react";
import { TbBook } from "react-icons/tb";

function Book() {
  return <Icon as={TbBook} boxSize={5} color="gray" />;
}

export default Book;
